const env = import.meta.env.VITE_REACT_APP_ENV;
interface URLs {
  graphUrl: string;
}

const devGraphUrl = `https://aims-api-dev.np.nutrien.com/graphql/`;
const devBlueGraphUrl = `https://dev-blue.aims-api.np.nutrien.com/graphql/`;
const devGreenGraphUrl = `https://dev-green.aims-api.np.nutrien.com/graphql/`;
const dev2GraphUrl = `https://aims-api-dev2.np.nutrien.com/graphql`;
const qaGraphUrl = `https://aims-api-qa.np.nutrien.com/graphql/`;
const qaGreenGraphUrl = `https://qa-green.aims-api.np.nutrien.com/graphql/`;
const qaBlueGraphUrl = `https://qa-blue.aims-api.np.nutrien.com/graphql/`;
const qa2GraphUrl = `https://aims-api-qa2.np.nutrien.com/graphql/`;
const uatGraphUrl = `https://aims-api-uat.np.nutrien.com/graphql`;
const prodGraphUrl = `https://aims-api.np.nutrien.com/graphql`;
const prodBlueGraphUrl = `https://prod-blue.aims-api.np.nutrien.com/graphql/`;
const prodGreenGraphUrl = `https://prod-green.aims-api.np.nutrien.com/graphql/`;
const trainingGraphUrl = `https://aims-api-training.np.nutrien.com/graphql`;
const trainingBlueGraphUrl = `https://training-blue.aims-api.np.nutrien.com/graphql/`;
const trainingGreenGraphUrl = `https://training-green.aims-api.np.nutrien.com/graphql/`;

let graphUrl;
switch (env) {
  case 'dev':
    graphUrl = devGraphUrl;
    break;
  case 'dev-blue':
    graphUrl = devBlueGraphUrl;
    break;
  case 'dev-green':
    graphUrl = devGreenGraphUrl;
    break;
  case 'dev2':
    graphUrl = dev2GraphUrl;
    break;
  case 'qa':
    graphUrl = qaGraphUrl;
    break;
  case 'qa-blue':
    graphUrl = qaBlueGraphUrl;
    break;
  case 'qa-green':
    graphUrl = qaGreenGraphUrl;
    break;
  case 'qa2':
    graphUrl = qa2GraphUrl;
    break;
  case 'uat':
    graphUrl = uatGraphUrl;
    break;
  case 'prod':
    graphUrl = prodGraphUrl;
    break;
  case 'prod-blue':
    graphUrl = prodBlueGraphUrl;
    break;
  case 'prod-green':
    graphUrl = prodGreenGraphUrl;
    break;
  case 'training':
    graphUrl = trainingGraphUrl;
    break;
  case 'training-blue':
    graphUrl = trainingBlueGraphUrl;
    break;
  case 'training-green':
    graphUrl = trainingGreenGraphUrl;
    break;
  default:
    graphUrl = devGraphUrl;
    break;
}

const apiConfig: URLs = {
  graphUrl: `${graphUrl}`,
};

export { apiConfig };
